import React, { Fragment, useContext } from "react";
import { Tab } from "@headlessui/react";
import AppContext from "../../appContext";
import PermissionEnum from "../../controllers/PermissionEnum";
import { classes } from "../Leafs";

interface EntriesBaseProps {
    TabComponent: React.ComponentType<{
        archived: boolean;
        notCompleted: boolean;
        results: boolean;
    }>;

    resultsPermission: PermissionEnum;
}

/*
 A reusable base component for entries with tabbed views
 (Not Completed, Completed, Results, Archived)
 */
const EntriesBase: React.FC<EntriesBaseProps> = ({ TabComponent, resultsPermission }) => {
    const context = useContext(AppContext);

    const tabs: {
        label: string;
        props: { archived: boolean; notCompleted: boolean; results: boolean };
        requiredPermission?: PermissionEnum;
    }[] = [
        { label: "Not Completed", props: { archived: false, notCompleted: true, results: false } },
        { label: "Completed", props: { archived: false, notCompleted: false, results: false } },
        { label: "Results", props: { archived: false, notCompleted: false, results: true }, requiredPermission: resultsPermission },
        { label: "Archived", props: { archived: true, notCompleted: false, results: false }, requiredPermission: PermissionEnum.SubmissionsArchive },
    ];

    const visibleTabs = tabs.filter(
        (tab) => !tab.requiredPermission || context.hasPermission(tab.requiredPermission)
    );

    return (
        <div className="bg-white p-2 shadow">
            <Tab.Group defaultIndex={-1}>
                <Tab.List className="flex space-x-1 rounded-xl bg-primary-500 p-1">
                    {visibleTabs.map((tab, idx) => (
                        <Tab key={idx} as={Fragment}>
                            {({ selected }) => (
                                <button className={classes(selected)}>{tab.label}</button>
                            )}
                        </Tab>
                    ))}
                </Tab.List>

                <Tab.Panels>
                    {visibleTabs.map((tab, idx) => (
                        <Tab.Panel key={idx}>
                            <TabComponent {...tab.props} />
                        </Tab.Panel>
                    ))}
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};

export default EntriesBase;